import { Button, Card, Col, Row } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Section from '../common/Section';
import IconButton from '../common/IconButton';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { FallbackProps } from 'react-error-boundary';

const Error500 = ({ error, resetErrorBoundary }: FallbackProps) => {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const date = useMemo(() => new Date().toLocaleString(), []);
  const errorText = `STACK: ${error?.stack ?? error?.message}
 PATH: ${window.location.pathname}
 DATE: ${date}
 AGENT: ${navigator.userAgent}`;

  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 pt-0">
        <Col sm={11} md={9} lg={7} xl={10} className="col-xxl-5">
          <Card className="text-center h-100">
            <Card.Body className="p-5">
              <div
                className="p-0 fw-black m-0 text-300"
                style={{
                  fontFeatureSettings: 'normal',
                  fontSize: 70
                }}
              >
                500
              </div>
              <div className="lead p-0 fs-1 mt-0 text-800 font-sans-serif fw-semi-bold">
                خطای غیرمنتظره!
              </div>
              <Form.Group className="text-start position-relative">
                <strong>متن خطا:</strong>
                <div className="position-relative">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    dir="ltr"
                    readOnly
                    value={errorText}
                    className="text-warning mb-2"
                  />
                  <IconButton
                    disabled={copied}
                    onClick={() => {
                      navigator.clipboard.writeText(errorText).then(() => {
                        setCopied(true);
                        setTimeout(() => {
                          setCopied(false);
                        }, 3000);
                      });
                    }}
                    variant="falcon-primary"
                    style={{ bottom: 10, right: 10 }}
                    className="position-absolute p-1 px-2"
                    iconClassName="fs--1"
                    icon={copied ? 'check' : 'copy'}
                  />
                </div>
              </Form.Group>
              <div className="d-flex mt-3 align-items-center gap-2">
                <Button
                  variant="outline-secondary"
                  onClick={() => resetErrorBoundary()}
                >
                  تلاش مجدد
                </Button>
                <Button variant="falcon-primary" onClick={() => navigate('/')}>
                  بازگشت به خانه
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default Error500;
